import { useQueryClient } from '@tanstack/react-query';
import { DOWNLOAD_QUERY_KEYS } from './keys';
import { type AssetDownloadAgreementsResponse } from '../../../../types/isomorphic/download.types';

// Typed read of the download-agreements entry owned by useDownloadAgreements;
// lives here so DOWNLOAD_QUERY_KEYS stays internal to api/download (ADR-014).
const useDownloadAgreementsData = (
  assetId: string | undefined
): AssetDownloadAgreementsResponse | null => {
  const queryClient = useQueryClient();
  return (
    queryClient.getQueryData<AssetDownloadAgreementsResponse>(
      DOWNLOAD_QUERY_KEYS.agreements(assetId)
    ) ?? null
  );
};

export default useDownloadAgreementsData;
